import { RealtimeHeader, RealtimeTable } from "./components";

const RealtimeManagement = () => {
  return (
    <div className="p-6">
      <RealtimeHeader />
      <RealtimeTable />
    </div>
  );
};

export default RealtimeManagement;